
  <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title pull-left">{{"586"|translate}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="cancel(); verForm.reset()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    <form class="p-t-15" role="form" #verForm="ngForm" (submit)="clickOk(); verForm.reset()">
    <div class="modal-body">
        <div class="row">
          <p class="body m-b-20 text-primary" innerHTML="{{'PWReq'|translate}}"></p>
          <div pgFormGroupDefault class="form-group form-group-default required" [class.has-error]="verTag.invalid && (verTag.dirty || verTag.touched)">
            <label>{{"79"|translate}}</label>
            <input type="password"  uppercase id="verTag" name="verTag"  required [(ngModel)]="newPass1"  #verTag="ngModel"  class="form-control" maxlength="100" (blur)="verPass()" >
          </div>
          <div pgFormGroupDefault class="form-group form-group-default required" [class.has-error]="verTag2.invalid && (verTag2.dirty || verTag2.touched)">
            <label>{{"79"|translate}} - {{"123"|translate}}</label>
            <input type="password"  uppercase id="verTag2" name="verTag2"  required [(ngModel)]="newPass2"  #verTag2="ngModel"  class="form-control" maxlength="100">
          </div>
          <div *ngIf="(verTag.dirty || verTag.touched) && (verTag2.dirty || verTag2.touched) && (verTag.value != verTag2.value)" >
            <label  class="error " >{{"130"|translate}}</label>
          </div>
          <div class="col-12">
            <button class="btn btn-primary btn-cons floatR" type="submit" [class.disabled]="!isValidPass || verForm.invalid || ((verTag.value != verTag2.value) && (verTag.dirty || verTag.touched) && (verTag2.dirty || verTag2.touched))"
                    [disabled]="!isValidPass || verForm.invalid || ((verTag.value != verTag2.value) && (verTag.dirty || verTag.touched) && (verTag2.dirty || verTag2.touched))">{{"31"|translate}}</button>
            <button type="button" class="btn btn-cons btn-default floatR" (click)="cancel(); verForm.reset()" >{{"30"|translate}}</button>
          </div>
        </div>


    </div>
    </form>

  </div>


